import React from 'react';

interface ServiceFeatureProps {
    icon: string;
    text: string;
}

const ServiceFeature: React.FC<ServiceFeatureProps> = ({ icon, text }) => {
    return (
        <div className="flex items-center space-x-3 hover:text-accent transition-colors duration-300 group">
            <span className="text-lg group-hover:scale-110 transition-transform duration-300">{icon}</span>
            <span>{text}</span>
        </div>
    );
};

export default ServiceFeature;
